module.exports = __webpack_public_path__ + "/img/TO-DPAK-Labeled-YsCB1J.svg";